import {isNullOrUndefined} from "./isNullOrUdefined";

export const isEmpty=(value)=>{
  return !value || isNullOrUndefined(value);
};
